import { textAlign } from "@mui/system";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, LineController, BarController, Title, Tooltip, Legend } from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, LineController, BarController, Title, Tooltip, Legend);

const MultiTypeChart = ({heading="", labels=[], barLabel="", barValues=[], lineLabel="", lineValues=[]}) => {

  if(!heading){
    return <span></span>
  }

  const data = {
    labels: labels,
    datasets: [
      {
        type: "line",
        label: lineLabel,
        data: lineValues,
        borderColor: "#00CCFF",
        backgroundColor: "#f5f5f5",
        borderWidth: 2, 
        pointRadius: 4,
        pointHoverRadius: 5, 
        fill: false,
        datalabels: {
          align:"top",
          color: "black", 
          font: {
            weight: "semibold",
          },
          padding: {
            bottom:1,
          },
        }
        
      },
      {
        type: "bar",
        label: barLabel,
        data: barValues,
        backgroundColor: "#03C03C",
        borderColor: "#03C03C",
        borderWidth: 1,
        barPercentage: 0.5, 
        categoryPercentage: 0.5,
        barThickness: 35,
        datalabels: {
          align: "center",
          color: "white",
          font: {
            weight: "semibold",
          },
        },
      }
    ],
  };

  const options = {
    // responsive: true,
    maintainAspectRatio:false,
    plugins: {
      legend: {
        position: "bottom", 
        labels: {
          boxWidth: 12, 
          padding: 20, 
        },
      },
      title: {
        display: true,
        text: "",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        stacked: false, 
        // max: Math.round(Math.max(...barValues, ...lineValues) * 1.1)
        max: 100
      },
    },
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "500px" }}>
      <h2 style={{ textAlign: "center", padding: "10px" }}>{heading}</h2>
      <div style={{ flexGrow: 1, minHeight: "300px" }}> 
        <Chart type="bar" data={data} options={options} />
      </div>
    </div>
  );
  
};

export default MultiTypeChart;